import { Button, Checkbox, Drawer, FormField, Input } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { PERFIS, SIM_NAO, VINCULOS } from '../hooks/useFiltrosUsuarios';
import type { FiltrosUsuarios } from '../types/Usuario';

type Props = {
  open: boolean;
  onClose: () => void;
  filtros: FiltrosUsuarios;
  alterar: (parcial: Partial<FiltrosUsuarios>) => unknown;
  onLimpar: () => void;
};

/** Mobile (< lg): só a coluna Nome aparece; aqui ficam os filtros das outras (spec 35 R11). */
export function UsuariosFiltrosDrawer({ open, onClose, filtros, alterar, onLimpar }: Props) {
  const { t } = useTranslation(['usuarios', 'common']);

  const texto = (campo: 'nome' | 'email', rotulo: string) => (
    <FormField label={rotulo}>
      <Input value={filtros[campo]} onChange={(e) => alterar({ [campo]: e.target.value })} />
    </FormField>
  );

  /** Escolha múltipla: valores marcados combinam com OU. */
  const varios = (
    campo: 'perfil' | 'entrou' | 'vinculo',
    rotulo: string,
    valores: readonly string[],
    nome: (v: string) => string,
  ) => {
    const marcados: readonly string[] = filtros[campo];
    return (
      <fieldset className="flex flex-col gap-2">
        <legend className="mb-1 text-sm font-medium text-foreground">{rotulo}</legend>
        {valores.map((v) => (
          <Checkbox
            key={v}
            label={nome(v)}
            checked={marcados.includes(v)}
            onCheckedChange={(c) =>
              alterar({ [campo]: c ? [...marcados, v] : marcados.filter((x) => x !== v) })
            }
          />
        ))}
      </fieldset>
    );
  };

  return (
    <Drawer open={open} onClose={onClose} ariaLabel={t('usuarios:filtros.botao')}>
      <Drawer.Header
        title={t('usuarios:filtros.botao')}
        onClose={onClose}
        dismissLabel={t('common:close')}
      />
      <Drawer.Body className="flex flex-col gap-4">
        {texto('nome', t('usuarios:colunas.nome'))}
        {texto('email', t('usuarios:colunas.email'))}
        {varios('perfil', t('usuarios:colunas.perfis'), PERFIS, (v) =>
          t(`usuarios:filtros.perfis.${v}` as never),
        )}
        {varios('entrou', t('usuarios:filtros.entrou.rotulo'), SIM_NAO, (v) =>
          t(`usuarios:filtros.entrou.${v}` as never),
        )}
        {varios('vinculo', t('usuarios:colunas.cadastro'), VINCULOS, (v) =>
          t(`usuarios:vinculo.${v}` as never),
        )}
      </Drawer.Body>
      <Drawer.Footer>
        <Button variant="secondary" onClick={onLimpar}>
          {t('usuarios:filtros.limpar')}
        </Button>
        <Button onClick={onClose}>{t('usuarios:filtros.fechar')}</Button>
      </Drawer.Footer>
    </Drawer>
  );
}
